import { Component, OnInit } from '@angular/core';
import { BookingService } from 'src/app/service/booking.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ProfileService } from 'src/app/shared/services/profile.service';
import { VerifyReservationComponent } from '../verify-reservation/verify-reservation.component';
import { ReservationConfirmationComponent } from '../reservation-confirmation/reservation-confirmation.component';

@Component({
  selector: 'app-booking-assistance-package',
  templateUrl: './booking-assistance-package.component.html',
  styleUrls: ['./booking-assistance-package.component.scss']
})
export class BookingAssistancePackageComponent implements OnInit {

  constructor(
    public matDialog : MatDialog,
    private bs: BookingService,
    private profileService: ProfileService, 
  ) { }

  sessions: any = [];
  profileData: any;

  addReservation(session){
    let booking = {
      session_id: session.id,
      date: session.date,
      title: session.title
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = booking
    let modalDialog = this.matDialog.open(VerifyReservationComponent, dialogConfig);
    modalDialog.afterClosed().subscribe((result) => {
      if(result == 'success' && !session.userreserved){
        this.bs.createSessionBooking(booking).then((response: any) => {
          let ReservationConfirmation = this.matDialog.open(ReservationConfirmationComponent, dialogConfig);
        })
      }
    })
  }

  ngOnInit(): void {    
    this.bs.getSessionDates().then((response: any) => {
      response.forEach(element => {
        let session = {
          id: element.id,
          date: element.data().date.toDate(),
          platform: element.data().platform,
          language: element.data().language,
          title: element.data().title,
          bookings: 0,
          userreserved: false,
        }
        this.sessions.push(session)
      });
      this.bs.getSessionBookings().then((bookings: any) => {
        const userID = JSON.parse(localStorage.getItem('user')).uid;
        this.sessions.forEach((session: any) => {
          bookings.forEach((booking: any) => {
            if(session.id == booking.data().session_id){
              session.bookings += 1
            }
            if(session.id == booking.data().session_id && userID == booking.data().uid){
              session.userreserved = true
            }
          });
        });
      })
    })
  }

}
